module.exports = __webpack_public_path__ + "img/icon-settings.b8794e8c.svg";